// selectors

export const getPagination = state => {
  return state.utilities.pagination;
};
